export const nameToUrl = (name: string) => {
    return name
        .toLowerCase() // Convert to lowercase
        .replace(/[^\p{L}0-9\s-]/gu, '') // Remove unwanted characters
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Remove consecutive hyphens
        .trim(); // Trim leading/trailing spaces
}

export const dataFromUrlName = (dataUrl: string) => {
    return dataUrl.slice(-36);
}
